import type { InquiryAttentionKey } from './inquiryProgressRules';

//
// The filter groups of Voortgang verantwoordelijken (see FilterAssetGroupKeys for the format): a value is
// `{group}{value}`. The status of each inquiry (notSent, sent, opened, overdue, answered), a responsible person's user
// id, and the attention points (late, notSent, choice, discuss, unsure, unanswered, ownership).
//
export enum FilterInquiryProgressGroupKeys {
  assetStatus = 'assetStatus$',
  outcomeStatus = 'outcomeStatus$',
  responsible = 'responsible$',
  attention = 'attention$',
}

/** The filter value of an attention point, typed so a renamed one does not leave a chip that matches nothing. */
export const getInquiryProgressAttentionFilterValue = (key: InquiryAttentionKey): string =>
  FilterInquiryProgressGroupKeys.attention + key;
